import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import LineItem from './LineItem'

class LineItemsRaw extends Component {
  static propTypes = {
    cart: PropTypes.object.isRequired,
    renderItem: PropTypes.func.isRequired,
    tagName: PropTypes.string.isRequired,
  }

  render() {
    const TagName = this.props.tagName

    return (
      <TagName>
        {this.props.cart.productLineItems.map((lineItem, index) => (
          <LineItem
            lineItem={lineItem}
            lineItemIndex={index}
            key={lineItem.lineItemId}
            renderItem={this.props.renderItem}
          />
        ))}
      </TagName>
    )
  }
}

export default connect((state) => ({
  cart: state.get('cart').toJS(),
}))(LineItemsRaw)
